export default __webpack_public_path__ + "static/hairwash1-67c49405fb0aecd6652f112d74695d28.svg";